export default __webpack_public_path__ + "static/media/publicationMenuIcon.d9dcef5a.svg";